import React from "react";
import icons from "../../icons";
import { Link } from "react-router-dom";
import LoginSlider from "./LoginSlider";
export default function SideRightContent() {
  return (
    <div className="sign-right-content">
      <div className="logo">
          <img src={icons.LOGO_LOGIN} alt="OPAL-Marketing Logo" />
      </div>
      <LoginSlider />
      <div className="company-logo">
        <h3 className="h3">Featured In:</h3>
        <ul>
          <li>
            <img src={icons.MICROSOFT_ICON} alt="Microsoft" />
          </li>
          <li>
            <img src={icons.PALOALTO_ICON} alt="Paloalto Networks" />
          </li>
          <li>
            <img src={icons.MOUSER_ICON} alt="Mouser Electronics" />
          </li>
          <li>
            <img src={icons.POWER_ICON} alt="Power Integration" />
          </li>
        </ul>
      </div>
    </div>
  );
}
